import { endpoints } from 'api/endpoints'
import { GetAllData, GetAllResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { Field, FieldDataServer, FieldsGetAllParams } from 'interfaces/api/templates.interfaces'
import { axios } from 'modules/axios'
import { defaultPagination, withoutPagination } from 'utils/pagination'

const getAll = async (params?: FieldsGetAllParams): GetAllResponse<Field> => {
  const { data: response } = await axios.request<GetAllData<Field>>({
    method: 'GET',
    url: endpoints.templates.fields.getAll(),
    params: {
      ...withoutPagination(params),
      ...defaultPagination(params),
    },
  })
  return response
}

const getSingle = async (id: number): GetOneResponse<Field> => {
  const { data: response } = await axios.request<Field>({
    method: 'GET',
    url: endpoints.templates.fields.getSingle(id),
  })
  return response
}

const create = async (data: FieldDataServer): GetOneResponse<Field> => {
  const { data: response } = await axios.request<Field>({
    method: 'POST',
    url: endpoints.templates.fields.create(),
    data,
  })
  return response
}

const update = async (id: number, data: FieldDataServer): GetOneResponse<Field> => {
  const { data: response } = await axios.request<Field>({
    method: 'PATCH',
    url: endpoints.templates.fields.update(id),
    data,
  })
  return response
}

const remove = async (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.templates.fields.remove(id),
  })

export const fieldsApi = {
  getAll,
  getSingle,
  create,
  update,
  remove,
}
